import { render } from "./Decoration.vue?vue&type=template&id=c7afa72c&scoped=true"
import script from "./Decoration.vue?vue&type=script&lang=js"
export * from "./Decoration.vue?vue&type=script&lang=js"

import "./Decoration.vue?vue&type=style&index=0&id=c7afa72c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7afa72c"]])

export default __exports__